import { Injectable } from '@angular/core';
import { Subject, Observable, throwError, BehaviorSubject, filter } from 'rxjs';
import { UtilsService } from '../utils/utils.service';
import { LoginService } from '../login/login.service';
import * as _ from 'lodash'
import { fontFamily } from 'html2canvas/dist/types/css/property-descriptors/font-family';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  private globalFilterStateSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public globalFilterState$: Observable<any> = this.globalFilterStateSubject.asObservable(); // Accessible from outside
  private filterPanelState: any = {}
  private subject = new Subject<void>();
  hideHierarchyFilter = new Subject<boolean>();
  private date: BehaviorSubject<any> = new BehaviorSubject<any>({ startDate: 'any', endDate: 'any', isRequestDate: 'any', dateFilterType: 'any' });
  private hierarchyMapping: any = []
  private filters: any = {};
  public userAccessLevelSwitched: boolean = false; // For user access level switching
  private questionOperators: any = [{
    text: "Equal To",
    value: "eq"
  }, {
    text: "Not Equal To",
    value: "ne"
  },
  //  {
  //   text: "Greater Than",
  //   value: "gt"
  // }, {
  //   text: "Less Than",
  //   value: "lt"
  // }, 
  {
    text: "Greater Than Equal To",
    value: "gt"
  }, {
    text: "Less Than Equal To",
    value: "lt"
  }];
  private textOperators: any = [{
    text: "Contains",
    value: "contains"
  }, {
    text: "Does Not Contains",
    value: "doesNotContains"
  }];
  public transactionOperator: any = [{
    text: "Equal To",
    value: "eq"
  }, {
    text: "Not Equal To",
    value: "ne"
  }, {
    text: "Contains",
    value: "eq_wildcard"
  }];
  private actionOperator: any = [{
    text: "Equal To",
    value: "eq"
  }, {
    text: "Not Equal To",
    value: "ne"
  }];
  constructor(
    public _utilService: UtilsService,
    private loginService: LoginService
  ) { }

  // Set values for global use
  setValuesForGlobalUse(params): void {
    const currentState = this.globalFilterStateSubject.getValue();
    if (params.account_id) {
      currentState.account_id = params.account_id;
    }
    if (params.project_id) {
      currentState.project_id = params.project_id;
    }
    // Set current applied access for logged in manager
    if (params.type == 'switchToThisLevel') {
      this.userAccessLevelSwitched = true;
      currentState['loggedInManager'] = params.newAccess;
    }
    if (params.type == 'applied_hierarchy_filter') {
      currentState['globalFilter'] = params.globalFilter;
    }
    this.globalFilterStateSubject.next(currentState);

  }

  hideHierarchyFilterFn(flag: boolean) {
    this.hideHierarchyFilter.next(flag)
  }

  // Open hierarchy search modal
  sendClickEventToOPenHierarchyGlobalFilter(data) {
    this.subject.next(data);
  }
  updateFilterVisiblity(data: any) {
    _.each(data, (value: any, key: any) => {
      this.filterPanelState[key] = value
    })

  }
  openGlobalFilterPanel(data: any) {
    const state = _.merge(this.filterPanelState, data)
    this.subject.next(state);
  }
  openHierarchyFilter(): Observable<any> {
    return this.subject.asObservable()
  }
  sendClickEventToUpdateGlobalFilter() {
    this.subject.next();
  }
  updateGlobalFilter(): Observable<any> {
    return this.subject.asObservable();
  }

  getSavedFilters(params: any) {
    // var url = $rootScope.Helpers.getApiUrl('api/filters/filter_list') ;
    let url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.getFilterList)
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  saveFilter(params: any) {
    let url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.saveFilter)
    return this._utilService.postAPICall(url, params, this._utilService.setHeaderWithParams(''))
  }

  removeSaveFilter(params) {
    let url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.removeFilter)
    return this._utilService.postAPICall(url, params, this._utilService.setHeaderWithParams(''))
  }

  getPossibleValues(params: any) {
    let url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchPossibleValues)
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))

  }

  getManagersList(params: any) {
    let url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchManagers)
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }
  getRolebasedManagersList(params: any) {
    let url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.searchRoleBased)
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }


  // Get logged in manager default access
  getDefaultAccess(cb) {
    var queryParamsObj = {};
    // check flag if switch level applied 
    if (this.userAccessLevelSwitched) {
      const currentState = this.globalFilterStateSubject.getValue();
      const loggedInManager = currentState['loggedInManager'];
      if (loggedInManager) {
        queryParamsObj['access_key'] = _.get(loggedInManager, 'access_key');
        queryParamsObj['project_id'] = _.get(loggedInManager, 'brand_id');
        queryParamsObj['manager_type'] = _.get(loggedInManager, 'manager_type');
        cb(queryParamsObj);
      } else {
        cb(null)
      }
    } else {
      this.getManagerDefaultAccessDetails((managerAccessDetail) => {
        if (managerAccessDetail) {
          queryParamsObj['access_key'] = _.get(managerAccessDetail, 'access_key');
          queryParamsObj['project_id'] = _.get(managerAccessDetail, 'brand_id');
          queryParamsObj['manager_type'] = _.get(managerAccessDetail, 'manager_type');
          cb(queryParamsObj);
        } else {
          cb(null)
        }
      });
    }
  }

  // Return access of manager
  getManagerDefaultAccess(object) {
    var accessObject = {};
    if(object) {
      accessObject['access_key'] = _.get(object, 'access_key');
      accessObject['project_id'] = _.get(object, 'brand_id');
      accessObject['manager_type'] = _.get(object, 'manager_type');
    }
    return accessObject;
  }

  getManagerDefaultAccessDetails(cb) {
    this.loginService.getManagerDetails().subscribe((response) => {
      if (_.hasIn(response, 'data.manager')) {
        const managerDetails = response.data?.manager;
        const loggedInManager = response.data?.loggedInManager;
        // Read default access from loggedInManager
        if (loggedInManager && loggedInManager.is_verified == true && _.has(loggedInManager, 'manager_type') && loggedInManager.manager_type == 3) {
          cb({ brand_id: loggedInManager.brand_id, account_id: loggedInManager.account_id, manager_type: loggedInManager.manager_type })
        }
        else if (loggedInManager && loggedInManager.is_verified == true && _.has(loggedInManager, 'access_key')) {
          const currentState = this.globalFilterStateSubject.getValue();
          currentState['loggedInManager'] = loggedInManager;
          currentState['manager'] = managerDetails;
          cb(loggedInManager);
        } else {
          var object = this.globalFilterStateSubject.getValue();
          // Read default access from manager_access
          var access = _.find(managerDetails.manager_access, (access) => {
            return (access.account_id == object.account_id && access.brand_id == object.project_id && access.is_verified == true && access.is_default_access == true)
          });
          if (!access) {
            let accessList = _.filter(managerDetails.manager_access, (access) => {
              return (access.account_id == object.account_id && access.brand_id == object.project_id)
            });
            if (accessList && accessList.length) {
              access = accessList[0]
            } else {
              let accountAccess = _.find(managerDetails.manager_access, (access) => {
                return (access.account_id == object.account_id && access.manager_type == 3)
              });
              if (accountAccess) {
                access = { brand_id: object.project_id, account_id: object.account_id, manager_type: 3 }
              }
            }
          }
          cb(access);
        }
      } else {
        cb(null);
      }

    });
  }
  getAppliedFilters() {
    const currentState = this.globalFilterStateSubject.getValue();
    return currentState.globalFilter
  }
  // Get brand's hierarchy level names & values
  setMappedHierarhcyLevels(brandDetail, cb) {
    if (brandDetail && _.has(brandDetail, 'is_single_touchpoint_setup') && brandDetail['is_single_touchpoint_setup'] == true) {
      if (brandDetail && _.has(brandDetail, 'hierarchy_list') && _.has(brandDetail, 'hierarchy_list_alias')) {
        var mappedHierarchyLevelNames = {};
        this.hierarchyMapping = [];
        for (let key in brandDetail.hierarchy_list) {
          var values = brandDetail.hierarchy_list[key];
          var hierarchyLevels = brandDetail.hierarchy_list_alias[key].values;
          var mappedLevelNames = {};
          for (var index in values) {
            mappedLevelNames[hierarchyLevels[index]] = values[index];
            this.hierarchyMapping.push({
              key: hierarchyLevels[index],
              label: values[index],
              options: ["ALL"],
              value: "ALL",
              enabled: false
            })
          }
          mappedHierarchyLevelNames = mappedLevelNames;
          const currentState = this.globalFilterStateSubject.getValue();
          currentState['hierarchyMapping'] = this.hierarchyMapping;
          currentState['mappedHierarchyLevelNames'] = mappedHierarchyLevelNames;
          cb({ 'mappedHierarchyLevelNames': mappedHierarchyLevelNames, hierarchyMapping: this.hierarchyMapping })
        }
      }
    }
  }

  getHierarchyStack(appliedHierarchy: any) {
    let stack: any = []
    _.each(appliedHierarchy, (hierarchy: any) => {
      if (hierarchy.value !== "ALL") {
        stack.push({
          "field_id": hierarchy.key,
          "group_key": [hierarchy.value]
        })
      }
    })
    return stack;
  }


  // Helper Function for prepare questions, actions, text and transaction filter.

  storeUniversalFilters(params: any) {
    const currentState = this.globalFilterStateSubject.getValue();
    currentState["universalFilter"] = params;
    this.globalFilterStateSubject.next(currentState);
  }
  getUniveralFilters() {
    const currentState = this.globalFilterStateSubject.getValue();
    return currentState.universalFilter;
  }

  savehuddleFilters(params: any) {
    const currentState = this.globalFilterStateSubject.getValue();
    currentState["huddleFilters"] = params;
    this.globalFilterStateSubject.next(currentState);
  }
  
  gethuddleFilters() {
    const currentState = this.globalFilterStateSubject.getValue();
    return currentState.huddleFilters;
  }

  prepareAndSetFilterData(detailObject: any, cb) {
    this.filters = {};
    let fieldDefinitions = _.get(detailObject, 'field_definitions');
    let detailedFeedbackItems = _.get(detailObject, 'detailed_feedback_items');
    let accordionsList = _.get(detailObject, 'accordions_list');
    let categoryList = _.get(detailObject, 'category_list')
    if (fieldDefinitions) {
      fieldDefinitions = JSON.parse(JSON.stringify(fieldDefinitions));
      const transactionFilter = this.prepareTagFilters(fieldDefinitions, detailedFeedbackItems);
      if (transactionFilter.filters && transactionFilter.filters.length) {
        this.filters["transaction_filter"] = transactionFilter;
      }
    }

    if (detailedFeedbackItems) {
      detailedFeedbackItems = JSON.parse(JSON.stringify(detailedFeedbackItems));
      const questionFilter = this.prepareQuestionAndTextFilter(detailedFeedbackItems);
      this.filters = _.merge(this.filters, questionFilter)
    }

    // if (accordionsList && accordionsList.length) {
    //   const actionFilter = this.prepareActionFilter(detailObject, accordionsList);
    //   if(actionFilter.filters && actionFilter.filters.length){
    //     this.filters["action_filter"] = actionFilter;
    //   }
    // }
    const actionFilter = this.prepareActionFilter(detailObject, accordionsList);
    if (actionFilter.filters && actionFilter.filters.length) {
      this.filters["action_filter"] = actionFilter;
    }
    if (categoryList && categoryList.length) {
      let categoryFilter: any = {
        field_id: "category",
        text: "Catedgory",
        operators: [],
        possibleValues: []
      }
      _.each(categoryList, (category: any) => {
        if (category.uuid && category.name && !category.is_deleted) {
          let filter = this.deepClone(category);
          filter.text = category.name;
          filter.value = category.uuid
          filter.children = _.map(filter.children, (data) => {
            data.text = data.name,
              data.value = data.uuid
            return data;
          })
          categoryFilter.operators.push(filter)
        }
      })

      if (!this.filters.textFilter) {
        this.filters.textFilter = {
          label: "Text-Based",
          filterType: "text_filter",
          sequence: 2,
          operators: this.textOperators,
          filters: []
        }
      }
      // this.filters.textFilter.filters.push(categoryFilter)
    }

    cb(this.filters)
  }

  getGolbalFilters() {
    return this.deepClone(this.filters);
  }

  setGlobalFilter(filters) {
    this.filters = filters;
  }

  prepareQuestionAndTextFilter(detailedFeedbackItems: any) {
    let questionFilterMapping: any = {}
    let filterType: string = '';
    // Sort questions by sequence no.
    detailedFeedbackItems = _.sortBy(detailedFeedbackItems, 'seq_no')
    // Filter those questions which do not have sequence no.
    var questionsWithoutSequence = detailedFeedbackItems.filter(function (question) {
      if (!question.seq_no) {
        return question;
      }
    })
    // Filter those questions which have sequence no.
    detailedFeedbackItems = detailedFeedbackItems.filter(function (question) {
      if (question.seq_no) {
        return question;
      }
    })

    // Concat questions which do not have sequence no at end
    if (questionsWithoutSequence && questionsWithoutSequence.length) {
      detailedFeedbackItems = detailedFeedbackItems.concat(questionsWithoutSequence)
    }

    _.each(detailedFeedbackItems, (question: any) => {
      let addToFilter: boolean = false;
      if (!question.is_deleted && question.type != "text" && question.is_displayed_on_dashboard && _.keys(question.prop).length) {
        filterType = 'questionFilter';
        if (!('questionFilter' in questionFilterMapping)) {
          questionFilterMapping['questionFilter'] = {
            label: "Question",
            filterType: "question_filter",
            sequence: 1,
            operators: this.questionOperators,
            filters: []
          }
        }
        addToFilter = true;
      }
      if (!question.is_deleted && question.type == "text" && !question.is_user_info) {
        filterType = 'textFilter';
        if (!('textFilter' in questionFilterMapping)) {
          questionFilterMapping['textFilter'] = {
            label: "Text-Based",
            filterType: "text_filter",
            sequence: 2,
            operators: this.textOperators,
            filters: [{
              "component_id": "586c8fe88eabb824403e2cf7",
              "text": "Customer comment",
              "question": "Customer comment",
              "field_id": "comments",
              "add_in_filter_list":true,
              "field_id_list": [],
              "is_primary_rating": false,
              "is_mandatory": true,
              "is_displayed_on_dashboard": true,
              "is_displayed_on_summary": true,
              "is_displayed_emoticon_on_dashboard": false,
              "conversation_type": "question",
              "type": "text",
              "label": "label_1734428120682Bkkbv",
              "possible_values": [],
              "tagsGroup": "access_group",
              "scale_rater_type": "1",
              "interaction_type": "text",
              "prop": {},
              "is_primary_comment": true,
              "seq_no": 45
            }]
          }
        }
        addToFilter = true;
      }

      if (addToFilter) {
        if (filterType == 'questionFilter') {
          question = this.getQuestionFilter(detailedFeedbackItems, question);
        }
        if(_.has(question,'group_id')){
          question.add_in_filter_list = false;
        }else{
          question.add_in_filter_list = true;
        }
        if (filterType == 'textFilter') {
          questionFilterMapping[filterType].filters[0].field_id_list.push(question.field_id)
        } else {
          questionFilterMapping[filterType].filters.push(question);
        }

      }

    });
    return questionFilterMapping;
  }

  prepareTagFilters(fieldDefinitions: any, detailedFeedbackItems: any) {
    detailedFeedbackItems = Helpers.deepClone(detailedFeedbackItems);
    let transactionFilter: any = {};
    let questionsList: any = {};
    if (detailedFeedbackItems && !_.isEmpty(detailedFeedbackItems)) {
      // const questionFilter = this.prepareQuestionAndTextFilter(detailedFeedbackItems)
      // const tmpList = _.get(questionFilter, 'questionFilter.filters', []);
      _.each(detailedFeedbackItems, (question: any) => {
        if(question.is_deleted != true && question.type != "text"){
          questionsList[question.field_id] = question;
        }
      })
    }

    _.each(fieldDefinitions, (field: any) => {
      if (field.es_filter) {
        if (transactionFilter[field.field_id]) {
          delete transactionFilter[field.field_id];
        }
        field.text = field.question || field.name;
        if (field.field_type == "response" || field.field_type == "interaction") {
          field.isQuestionAsTagFilter = true;
          if (questionsList[field.field_id] && questionsList[field.field_id].type) {
            field.type = questionsList[field.field_id].type;
          }
        }
        if(field.field_id && field.field_type == "response"  && questionsList[field.field_id] && !_.isEmpty(questionsList[field.field_id].prop) && (questionsList[field.field_id].type == "multi-select" || questionsList[field.field_id].type == "single-select")){
          field.possible_values = [];
          let possibleValues: any = [];
          _.each(questionsList, (question: any) => {
            if(question.group_id && question.group_id == field.field_id){
              field.possible_values.push({
                label: question.question || question.text,
                value: question.value,
                field_id: question.field_id,
                question_id: question.field_id
              })
            }
          })
          // _.each(field.prop, (value: any) => {
          //   possibleValues.push({
          //     label: value.label,
          //     value: value.value,
          //     field_id: value.field_id,
          //     question_id: value.field_id
          //   })
          // })
          // field.possible_values = possibleValues;
        }
        if (!_.isEmpty(field.possible_values)) {
          var possibleValues: any = [];
          _.each(field.possible_values, function (value: any) {
            if (field.field_type && field.field_type == "response" && questionsList[value.field_id] && !questionsList[value.field_id].is_deleted) {
              value.label = (questionsList[value.field_id].question) ? questionsList[value.field_id].question : questionsList[value.field_id].text;
              possibleValues.push(value)
            } else if (field.field_type && field.field_type == "interaction") {
              var interactionField: any = {}
              interactionField.value = value;
              interactionField.label = questionsList[value] ? (questionsList[value].question ? questionsList[value].question : questionsList[value].text) : value
              possibleValues.push(interactionField)
            } else if (!(field.field_type && field.field_type == "response")) {
              possibleValues.push({ "label": value, "value": value })
            }
          })

        }
        field.add_in_filter_list = true;
        field.options = (field.possible_values) ? possibleValues : [];
        // Questions shown under Metadata use their option list, not a value search.
        field.isSearchEnabled = field.isQuestionAsTagFilter ? false : !(field.possible_values && field.possible_values.length);
        transactionFilter[field.field_id] = field;
        if (field && field.child) { 
          transactionFilter = this.getChildMapping(field.child, transactionFilter, questionsList)
        }
      }

    })

    return {
      label: "Metadata",
      filterType: "transaction_filter",
      sequence: 4,
      operators: this.transactionOperator,
      filters: Object.values(transactionFilter)
    };

  }


  prepareActionFilter(detailObject: any, accordionsList: any) {
    const accordions = {
      "status": {
        "display_name": "Status"
      },
      "category": {
        "display_name": "Category"
      },
      "sub_category_id_list": {
        "display_name": "Sub Category"
      },
      "assignee": {
        "display_name": "Assignee"
      },
      "follower": {
        "display_name": "Follower"
      },
      "tag": {
        "display_name": "Tags"
      }
    }
    if (accordionsList && accordionsList.length) {
      accordionsList.forEach(function (accordion: any) {
        if (accordion && accordion.field_id)
          accordions[accordion.field_id] = accordion;
      })
    }


    let categoryHash = this.prepareHashForCategory(detailObject);
    var statusList = this.getListAndMapWithTextAndValueByType(detailObject, 'status_list', 'uuid', 'name');
    var tagList = this.getListAndMapWithTextAndValueByType(detailObject, 'tag_list', 'uuid', 'name');
    var categoryList = this.getListAndMapWithTextAndValueByType(detailObject, 'category_list', 'uuid', 'name');
    var roleBasedOperator = this.prepareHierarchyLevelDetail(detailObject.hierarchy_list, detailObject.hierarchy_list_alias)
    let customFilters = [{
      "id": "ltms_universal_action_filter_TAT_status",
      "key": "tat_status_list",
      "name": "TAT Status (new)",
      "operators": [{
        "value": "eq",
        "text": "Equal To"
      }],
      "possibleValues": [{
        "value": "within",
        "text": "Inside TAT"
      }, {
        "value": "breached",
        "text": "Outside TAT"
      }],
      "add_in_filter_list":true,
      "visible": detailObject.is_new_tat_filter_enabled
    }, {
      "id": "ltms_universal_action_filter_status",
      "key": "status_id_list",
      "name": accordions["status"]["display_name"],
      "operators": [{
        "value": "eq",
        "text": "Equal To"
      }, {
        "value": "ne",
        "text": "Not Equal To"
      }],
      "add_in_filter_list":true,
      "possibleValues": statusList
    }, {
      "id": "ltms_universal_action_filter_category",
      "key": "category_id_list",
      "name": accordions["category"]["display_name"],
      "operators": [{
        "value": "eq",
        "text": "Equal To"
      }, {
        "value": "ne",
        "text": "Not Equal To"
      }],
      "add_in_filter_list":true,
      "possibleValues": categoryList
    }, {
      "id": "ltms_universal_action_filter_sub_category",
      "key": "sub_category_id_list",
      "visible": false,
      "name": "Sub " + accordions["category"]["display_name"],
      "operators": [{
        "value": "eq",
        "text": "Equal To"
      }, {
        "value": "ne",
        "text": "Not Equal To"
      }],
      "add_in_filter_list":true,
      "possibleValues": []
    }, {
      "id": "ltms_universal_action_filter_tags",
      "key": "tag_id_list",
      "name": accordions["tag"]["display_name"],
      "operators": [{
        "value": "eq",
        "text": "Equal To"
      }, {
        "value": "ne",
        "text": "Not Equal To"
      }],
      "add_in_filter_list":true,
      "possibleValues": tagList
    }, {
      "id": "ltms_universal_action_filter_assignee",
      "key": "assigned_to_id_list",
      "name": accordions["assignee"]["display_name"],
      "operators": [{
        "value": "eq",
        "text": "Equal To"
      }],
      "add_in_filter_list":true,
      "isSearchEnabled": true,
      "possibleValues": []
    }, {
      "id": "ltms_universal_action_filter_rolebased_assignee",
      "key": "role_assigned_to",
      "operators": roleBasedOperator,
      "name": "Currently assigned to",
      "add_in_filter_list":true,
      "isSearchEnabled": true,
      "possibleLevel": null,
      "possibleValues": []
    }];

    var isRoleBasedProject = this.checkIsRoleBased(detailObject);

    if (isRoleBasedProject) {
      customFilters = customFilters.filter(function (value) { return (value.id != 'ltms_universal_action_filter_assignee') });
    } else {
      customFilters = customFilters.filter(function (value) { return (value.id != 'ltms_universal_action_filter_rolebased_assignee') });
    }

    // $timeout(function() {
    //     initialiseActionSelect();
    //     //check for rolebased project
    //     if (checkIsRoleBased()) {
    //         // prepare data with latest hierarchy
    //         $("#ltms-action-filter-rolebased-level-select option").remove();
    //         $("#ltms-action-filter-rolebased-level-select").append("<option></option>");
    //         initializeRolebasedAssigneeSelect2();
    //     } else {
    //         initialiseActionAssignee();
    //     }
    // }, 0);
    // console.log("customFilters", customFilters)
    let actionCustomFilters = customFilters;
    return {
      label: "Action",
      filterType: "action_filter",
      sequence: 3,
      operators: this.actionOperator,
      filters: this.deepClone(customFilters)
    };

  }

  prepareHierarchyLevelDetail(dataList: any, dataListAlias: any) {
    var detail = [{
      "value": "level",
      "text": "Level"
    }, {
      "value": "role",
      "text": "Roles"
    }];
    if (dataList && dataListAlias) {
      detail = []
      var keys = Object.keys(dataList);
      var lastKey = keys[keys.length - 1];
      var lastVal = dataList[lastKey];
      if (lastVal && lastVal.length) {
        _.each(lastVal, function (val, index) {
          // replace spcace with underscore
          val = val.replace(/ /g, "_");
          detail.push({
            "value": dataListAlias[lastKey]['values'][index],
            "text": val
          });
        })
      }
    }
    return detail;;
  }

  prepareHashForCategory(detailObject: any) {
    var categoryList = this.deepClone(detailObject.category_list);
    var categoryMap = {};
    if (categoryList && categoryList.length) {
      _.each(categoryList, (category: any) => {
        if (category["is_deleted"] != true && category["is_enabled"] != false && Helpers.isValidJSON(category)) {
          categoryMap[category["uuid"]] = (typeof category == 'string') ? JSON.parse(category) : Helpers.deepClone(category);
          categoryMap[category["uuid"]]["noOfChild"] = _.get(category, "children.length");
          if (categoryMap[category["uuid"]]["noOfChild"]) {
            _.each(category["children"], (categoryChild: any) => {
              if (categoryChild["is_deleted"] != true && categoryChild["is_enabled"] != false && Helpers.isValidJSON(categoryChild)) {
                categoryMap[categoryChild["uuid"]] = this.deepClone(categoryChild);
                categoryMap[categoryChild["uuid"]]["parentId"] = category["uuid"];
              }
            });
            delete categoryMap[category["uuid"]]["children"]
          }
        }
      })
    }

    return categoryMap;
  }

  getListAndMapWithTextAndValueByType(detailObject, type, valueKey, textKey) {
    var list: any = [{ "value": "all", text: "Select All" }];
    _.each(detailObject[type], (elem: any) => {
      if (elem.is_enabled != false && elem.is_deleted != true) {
        list.push({ "value": elem[valueKey], "text": elem[textKey] });
      }
    });
    return list;
  }

  checkIsRoleBased(detailObject) {

    if (_.get(detailObject, "action_management_configuration.isRoleBasedAssignee") && _.get(detailObject, "is_single_touchpoint_setup")) {
      return true;
    } else {
      return false;
    }
  }

  getChildMapping(field, transactionFilter, questionsList) {
    if (field && field.field_id && field.es_filter && !transactionFilter[field.field_id]) {
      field.text = field.name;
      if (field.field_type == "response" || field.field_type == "interaction") {
        field.isQuestionAsTagFilter = true;
        if (questionsList && questionsList[field.field_id] && questionsList[field.field_id].type) {
          field.type = questionsList[field.field_id].type;
        }
      }
      if (!_.isEmpty(field.possible_values)) {
        var possibleValues: any = [];
        _.each(field.possible_values, function (value) {
          if (field.field_type && field.field_type == "response" && questionsList && value && questionsList[value.field_id] && !questionsList[value.field_id].is_deleted) {
            value.label = (questionsList[value.field_id].question) ? questionsList[value.field_id].question : questionsList[value.field_id].text;
            possibleValues.push(value)
          } else if (!(field.field_type && field.field_type == "response")) {
            possibleValues.push({ "label": value, "value": value })
          }

        })

      }
      field.add_in_filter_list = true;
      field.options = (field.possible_values) ? possibleValues : [];
      field.isSearchEnabled = field.isQuestionAsTagFilter ? false : !(field.possible_values && field.possible_values.length);
      transactionFilter[field.field_id] = field
    }
    if (field && field.child && field.child) {
      transactionFilter = this.getChildMapping(field.child, transactionFilter, questionsList)
    }
    return transactionFilter;
  }

  getQuestionFilter(detailedFeedbackItems: any, question: any) {
    question.options = [];
    question.extendedOptions = [];
    let options: any = [];
    _.each(question.prop, (value) => {

      var addToOtion = (question.type == "multi-select") ? false : true;
      if (question.component_type == 'ltms-nps-five-star-rater' && Helpers.brandDetail && Helpers.brandDetail.extended_rater_type == 4 && value.value != undefined && value.value != null) {
        // Get new options for the extended rater type
        options.push(this.getNewOptionsForExtendedRaterType(value));
        question.extended_rater_type = true;
      }
      if (question.type == "multi-select" && value.value != undefined && value.value != null) {
        addToOtion = this.checkOptionExistence(detailedFeedbackItems, value, question.field_id);
      }
      if ((question.type == "multi-select" || question.type == "single-select") && (value.label && value.value != undefined && value.value != null)) {
        value.label = value.label;
      } else if (value.label && value.value != undefined && value.value != null) {
        value.label = value.label + "(" + value.value + ")"
      } else {
        value.label = value.value;
      }
      if (addToOtion) {
        question.options.push(value)
      }

    })
    question.options = _.sortBy(question.options, 'value').reverse();
    if (question.component_type == 'ltms-nps-five-star-rater' && question.extended_rater_type == true && options.length > 0) {
      question.options = _.sortBy(this.removeDuplicateOptionsOfExtendedRater(options), 'value').reverse();
    }
    question.text = question.question || question.text
    return question;
  }

  getNewOptionsForExtendedRaterType(value) {
    let obj = {};
    if (value.value >= 9) {
      obj = this.getLabelAndValue(value.label, 5, '#008000')
    }
    if (value.value > 6 && value.value <= 8) {
      obj = this.getLabelAndValue(value.label, 4, '#ffa500')
    }
    if (value.value <= 6) {
      if (value.value > 4 && value.value <= 6) {
        obj = this.getLabelAndValue(value.label, 3, '#ff0000')
      }
      if (value.value > 2 && value.value <= 4) {
        obj = this.getLabelAndValue(value.label, 2, '#ff0000')
      }
      if (value.value <= 2) {
        obj = this.getLabelAndValue(value.label, 1, '#ff0000')
      }
    }
    return obj;
  }

  checkOptionExistence(detailedFeedbackItems: any, value: any, fieldId: any) {
    var option = _.filter(detailedFeedbackItems, (question) => {
      if(question.value == value.value && question.group_id == fieldId && !question.is_deleted){
        value.question_id = question.field_id;
        return true
      }else{
        return false
      }
      
    });
    if (option && !_.isEmpty(option)) {
      return true;
    } else {
      return false;
    }
  }

  removeDuplicateOptionsOfExtendedRater(options) {
    var newOptions: any = [];
    if (options.length > 0) {
      var uniqueObject: any = {};
      for (var i in options) {
        const objTitle = options[i]['value'];
        uniqueObject[objTitle] = options[i];
      }
      for (i in uniqueObject) {
        newOptions.push(uniqueObject[i]);
      }
    }
    return newOptions;
  }

  getLabelAndValue(label, value, color) {
    return {
      value: value,
      label: label + "(" + value + ")",
      active_color: color
    }
  }

  getMultiSelectQuestionFilter(appliedFilter) {
    let multiSelectFilters: any = {}
    // let questionFilter = _.find(this.filters, { filterType: "question_filter" })
    _.each(Helpers.deepClone(appliedFilter), (filter: any) => {
      if (filter?.fieldType == "multi-select") {
        _.each(filter?.values, (value: any) => {
          const option = _.find(filter.possibleValues, { "value": value });
          const questionId = option?.question_id || option?.field_id;
          if (option && !_.isEmpty(option) && questionId) {
            multiSelectFilters[questionId] = {
              "is_all_selected": false,
              "filter_type": "",
              "selected_values": option.text,
              "action": filter.operator,
              "group_id": filter.fieldId,
              "values": [value]
            }
            if (this.isQuestionAddedAsTagFilter(filter)) {
              multiSelectFilters[questionId].field_type = filter.fieldDefinitionType || "response";
              multiSelectFilters[questionId].is_question_as_tag = true;
            }
          }
        })
      }
    })
    return multiSelectFilters;
  }

  isQuestionAddedAsTagFilter(filter: any): boolean {
    if (!filter) {
      return false;
    }
    if (filter.isQuestionAsTagFilter === true || filter.is_question_as_tag === true) {
      return true;
    }
    if (filter.fieldDefinitionType == "response" || filter.fieldDefinitionType == "interaction") {
      return true;
    }
    if (filter.filterType !== "transaction_filter") {
      return false;
    }
    const fieldId = filter.fieldId || filter.field_id;
    const tagFilters = _.get(this.filters, "transaction_filter.filters", []);
    const field = _.find(tagFilters, (item: any) => item.field_id == fieldId || item.key == fieldId);
    return !!(field && (field.field_type == "response" || field.field_type == "interaction" || field.isQuestionAsTagFilter));
  }

  excludeMultiSelectFilter(filters) {
    var appliedFilter: any = JSON.parse(JSON.stringify(filters));
    var group_id_list: any = [];
    _.each(appliedFilter["question_filter"], function (filter, fieldId) {
      if (filter && filter?.group_id && group_id_list.indexOf(filter?.group_id) < 0) {
        group_id_list.push(filter?.group_id)
      }
    })

    if (group_id_list.length) {
      _.each(group_id_list, function (questionId) {
        // const filter = appliedFilter["question_filter"][questionId];
        // appliedFilter["question_filter"][questionId].action = (filter.is_all_selected) ? filter.action : 'eq';
        // appliedFilter["question_filter"][questionId].values = [1]
        delete appliedFilter["question_filter"][questionId] // to fix not equal to issue for Multi Option Multi Select
      })
    }

    if (appliedFilter && appliedFilter.tag_filter && !_.isEmpty(appliedFilter.tag_filter)) {
      group_id_list = []
      _.each(appliedFilter["tag_filter"], (filter: any, fieldId: any) => {
        if (filter && filter?.group_id && group_id_list.indexOf(filter?.group_id) < 0) {
          // const groupfilter = appliedFilter["tag_filter"][filter.group_id];
          // appliedFilter["tag_filter"][filter.group_id].action = (groupfilter.is_all_selected) ? groupfilter.action : 'eq';
          // appliedFilter["tag_filter"][filter.group_id].values = [1]
          delete appliedFilter["tag_filter"][filter?.group_id] // to fix not equal to issue for Multi Option Multi Select
        }
      })
    }
    return appliedFilter
  }

  getFormatedUniversalFilter(filters: any) {
    let formatedFilters: any = {}
    let stringfyTextFilter: boolean = false;
    if (filters && filters.length) {
      _.each(filters, (filter: any) => {
        const isQuestionAsTag = this.isQuestionAddedAsTagFilter(filter);
        // Questions configured as tag/metadata stay as tags in the UI, but the API
        // query must be sent under question_filter.
        let filterType: string = filter?.filterType === 'transaction_filter' ? 'tag_filter' : filter.filterType;
        if (isQuestionAsTag) {
          filterType = 'question_filter';
        }
        if (!formatedFilters[filterType]) {
          formatedFilters[filterType] = {}
        }

        let formatedData: any = {
          "action": filter.operator,
          "values": filter.values,
          "selected_values": filter.valueText,
        }
        if (isQuestionAsTag) {
          formatedData.field_type = filter.fieldDefinitionType || filter.field_type || "response";
          formatedData.is_question_as_tag = true;
        }
        if (filter?.filterType === 'question_filter' && filter?.fieldId == "primary_rating" && filter?.componentType == 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
          formatedData.values = filter.mappedValues;
          formatedData.selected_values = filter.mappedValueText;
        }

        if(_.has(filter,"isAllSelected")){
          formatedData["is_all_selected"] = filter.isAllSelected
        }
        
        if (filter?.appliedFrom) {
          formatedData['applied_from'] = filter['appliedFrom'];
        }

        if (filterType == "text_filter") {
          const data = this.getFormatedTextFilters(filter)
          formatedData = data.formatedData;
          if (formatedFilters[filterType]) {
            formatedData = _.merge(formatedFilters[filterType], data.formatedData)
          }
          formatedFilters[filterType] = formatedData;
          if (data.stringfyFilter) {
            stringfyTextFilter = true;
          }
        } else {
          if (filterType == 'action_filter') {
            formatedData.idToPrepend = filter.idToPrepend
            formatedData.filterName = filter.fieldText
            formatedData.details = this.deepClone(filter.details)
          }
          formatedFilters[filterType][filter.fieldId] = formatedData;
        }

      })
    }
    if (stringfyTextFilter) {
      formatedFilters.text_filter = JSON.stringify(formatedFilters.text_filter)
    }
    return formatedFilters
  }

  getFormatedTextFilters(filter: any) {
    let formatedData: any = {}
    let stringfyFilter: boolean = false;
    if (filter.filterType == "text_filter") {
      if (filter.fieldId == 'category') {
        let mapData: any = {};
        let levels: any = {}
        _.each(filter.details, (detail: any) => {
          mapData[detail.value] = detail.text
          levels["level_" + detail.level] = [detail.value]
        })
        formatedData["comments"] = {
          "categories": {
            "field_id": "comments",
            "map": mapData,
            "levels": levels
          }
        }
      } else {
        stringfyFilter = false;
        formatedData["free_text_search"] = {
          "field_id_list": (filter.fieldIdList && filter.fieldIdList.length) ? filter.fieldIdList : [filter.fieldId],
          "contains": [],
          "doesNotContains": []
        }
        if (filter.operator == "contains") {
          formatedData.free_text_search.contains = filter.values
        }
        if (filter.operator == "doesNotContains") {
          formatedData.free_text_search.doesNotContains = filter.values
        }
      }

    }
    return { formatedData, stringfyFilter };
  }

  deepClone(data: object) {
    if (data) {
      return JSON.parse(JSON.stringify(data))
    } else {
      return data
    }
  }
  
  resetFilters(isUniversalFilter: boolean, isHierarchFilter: boolean) {
    this.userAccessLevelSwitched = false;
    const currentState = this.globalFilterStateSubject.getValue();
    if (isUniversalFilter) {
      delete currentState['globalFilter'];
      delete currentState['universalFilter'];
      delete currentState['loggedInManager'];
    }
    if (isHierarchFilter) {
      delete currentState['globalFilter'];
    }

    this.globalFilterStateSubject.next(currentState)
  }

  hasFilterEditAccess(accountId: string) {
    var isAdminUser = false;
    var isAccountManager = false;
    var isBrandManager = false;
    var isAccount = _.get(Helpers, 'isAccount', false);
    isAccount = (isAccount == 'true' || isAccount == true) ? true : false;

    isAdminUser = this.checkForAdminUser();

    if (isAdminUser) {
      return true;
    } else {
      isAccountManager = this.checkForAccountManager(accountId);
      if (isAccountManager) {
        return isAccountManager;
      } else {
        return false
      }
    }
  }

  checkForAdminUser() {
    var isAdminUser = false;
    var loginResponse = _.get(Helpers, 'managerDetails');
    if (loginResponse) {
      if (_.get(loginResponse, 'manager.access_rules.admin.modules.setting.visible') &&
        loginResponse.manager.email_address && loginResponse.manager.email_address.includes('@litmusworld.com')) {
        isAdminUser = true;
      }
    }
    return isAdminUser;
  }
  checkForAccountManager(accountId: string) {
    var managerAccess = _.get(Helpers, 'managerDetails');
    var isAccountManager = false;
    var accessList = _.get(managerAccess, 'manager.manager_access', []);
    if (accessList && accessList.length) {
      const accountAccess = _.find(accessList, { account_id: accountId, manager_type: 3 })
      isAccountManager = (accountAccess && !_.isEmpty(accountAccess)) ? true : false;
      // _.each(accessList, (access: any) => {
      //   if (access.account_id == accountId && access.manager_type == 3) {
      //     isAccountManager = true;
      //   }
      // });
    }
    return isAccountManager;
  }
}